import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const SelectWithSearch = ({ label, options, onChange, value, disabled }) => {
  const handleChange = (event, option) => {
    onChange(option === null ? null : option.value);
  };

  const selectedValue = value === null ? null : options.find(option => option.value === value);

  return (
    <Autocomplete
      disabled={disabled}
      options={options}
      onChange={handleChange}
      getOptionLabel={({ label: optionLabel }) => optionLabel}
      renderInput={params => <TextField {...params} label={label} />}
      value={selectedValue}
    />
  );
};

SelectWithSearch.defaultProps = {
  value: null,
  disabled: false,
};

SelectWithSearch.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  disabled: PropTypes.bool,
};

export default SelectWithSearch;
